import { AxiosError } from "axios";

export interface ToastContextInterface {
    info: (message: string) => void;
    success: (message: string) => void;
    warning: (message: string) => void;
    error: (error: string | Error | AxiosError) => void;
    remove: (id: number) => void;
}

export interface ToastProviderProps {
    children: React.ReactNode;
}

export const MAX_TOASTS = 3;
